import type { Me } from '@otryad/shared';

import { apiUrl } from './trpc';

/** REST-вызовы админ-аутентификации (BLUEPRINT 6): cookie ставит API, поэтому `credentials: include`. */

export interface TelegramWidgetUser {
  id: number;
  first_name: string;
  last_name?: string;
  username?: string;
  photo_url?: string;
  auth_date: number;
  hash: string;
}

export type AdminAuthErrorCode =
  'forbidden' | 'bad_signature' | 'not_configured' | 'not_found' | 'network';

export type AdminAuthResult =
  { ok: true; user: Me } | { ok: false; error: AdminAuthErrorCode; status: number };

async function post(path: string, body: unknown): Promise<AdminAuthResult> {
  let res: Response;
  try {
    res = await fetch(`${apiUrl}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(body),
    });
  } catch {
    return { ok: false, error: 'network', status: 0 };
  }
  const json = (await res.json().catch(() => null)) as
    { ok: true; user: Me } | { ok: false; error?: AdminAuthErrorCode } | null;
  if (res.ok && json && json.ok) return { ok: true, user: json.user };
  const error = json && !json.ok && json.error ? json.error : 'network';
  return { ok: false, error, status: res.status };
}

export function loginWithWidget(user: TelegramWidgetUser): Promise<AdminAuthResult> {
  return post('/admin-auth/telegram', user);
}

export function loginDev(tgId: string): Promise<AdminAuthResult> {
  return post('/admin-auth/dev', { tgId });
}

export async function logout(): Promise<void> {
  await fetch(`${apiUrl}/admin-auth/logout`, { method: 'POST', credentials: 'include' }).catch(
    () => undefined,
  );
}
